import { SxProps, Theme } from '@mui/material';
import { siteColors } from '../../../../shared/constants/colors';

export function getStyles(isDesktopOrLaptop: boolean):  ({ [key:string]: SxProps<Theme> }) {
    return {
        root: {
            width: 'auto',
            minWidth: '100%',
            backgroundColor: '#343A40',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: '0',
            marginRight: '0',
            paddingTop: '20px',
            paddingBottom: '20px',
            display: 'flex'
        },
        contentContainer: {
            flexDirection: 'column',
            alignItems: 'center',
            display: 'flex',
            lineHeight: '20px'
        },
        logoLink: {
            marginBottom: '10px'
        },
        contactLink: {
            color: 'white',
            display: 'inline',
            textDecoration: 'none',
            textDecorationStyle: 'solid',
            fontWeight: 300,
            ":hover": {
                textDecoration: 'underline'
            }
        },
        copyrightText: {
            color: '#fff',
            textAlign: 'center',
            marginTop: '5px',
            fontSize: '14px',
            fontWeight: 400
        },
        privacyPolicySection: {
            color: '#fff',
            textAlign: 'center',
            marginTop: '5px',
            fontSize: '16px',
            fontWeight: 400,
            display: 'block'
        },
        patentText: {
            display: 'inline'
        },
        privacyPolicyLink: {
            color: '#fff',
            display: 'inline',
            textDecoration: 'none',
            ":hover": {
                textDecoration: 'underline'
            },
        },
        verticalDivider: {
            marginLeft: '5px',
            marginRight: '5px',
            display: 'inline'
        }
    }
};
